let slideshow;
const initSlideshow = () => {
  slideshow = new Swiper(".slideshow-slider", {
    loop: true,
    speed: 5000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    initialSlide: 1,
    slidesPerView: 1,
    spaceBetween: 40,
    centeredSlides: true,
    breakpoints: {
      500: {
        slidesPerView: 2,
        centeredSlides: false
      },
      768: {
        slidesPerView: 4.4,
        centeredSlides: false
      },
      1024: {
        slidesPerView: 5.6
      },
    },
    navigation: {
      prevEl: '.slideshow-slider__button.prev',
      nextEl: '.slideshow-slider__button.next'
    }
  });
};

window.addEventListener("DOMContentLoaded", initSlideshow);
